module.exports = __webpack_public_path__ + "avatar6.svg?121293bf585b49499718db7979051662";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Avatar-Blue-Pool/avatar6.svg
// module id = 142
// module chunks = 2